import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { MinimalAlert, MinimalButton } from '@ovasabi/ui-minimal'
import { incomingOrders, SILENCE_MS, shouldRing, useIncomingOrders } from './incomingOrders'

/**
 * The kitchen's standing alert for paid orders it has not accepted.
 *
 * Unlike the timed toasts beside it, this stays on screen for as long as an
 * order is waiting: it is the visible half of the repeating bell, and the
 * place to silence it. Accepting the order is what clears it.
 */
export function IncomingOrderAlert() {
  const navigate = useNavigate()
  const state = useIncomingOrders()
  // Re-render when a silence runs out, so the Silence button comes back.
  const [, wake] = useState(0)
  useEffect(() => {
    const left = state.silencedUntil - Date.now()
    if (left <= 0) return
    const timer = window.setTimeout(() => wake((n) => n + 1), left + 50)
    return () => window.clearTimeout(timer)
  }, [state.silencedUntil])
  const count = state.waiting.length
  if (count === 0) return null
  const ringing = shouldRing(state, Date.now())
  const review = () => navigate(count === 1 ? `/orders/${state.waiting[0]}` : '/orders')
  return (
    <MinimalAlert
      tone="warning"
      title={count === 1 ? 'New order waiting' : `${count} new orders waiting`}
      data-incoming-orders={count}
      action={<>
        <MinimalButton size="sm" onClick={review}>{count === 1 ? 'Review order' : 'Review orders'}</MinimalButton>
        {ringing && (
          <MinimalButton size="sm" variant="ghost" onClick={() => incomingOrders.silence()}>
            Silence for {Math.round(SILENCE_MS / 60_000)} min
          </MinimalButton>
        )}
      </>}
    >
      {count === 1 ? 'A customer has paid.' : 'Customers have paid.'} The alert keeps ringing until you accept {count === 1 ? 'it' : 'them'}.
    </MinimalAlert>
  )
}
